import { DocumentFormSettingsKey, VideoFormSettingsKey  } from "../../form-settings/form-experience/form-settings-keys.js";

type AdditionalResources = "recommended-resources" | "general-modal";
type AllFormTypes = Exclude<DocumentFormSettingsKey, "digital-maturity-assessment"> | VideoFormSettingsKey | AdditionalResources;
const AllFormTypes = [
  ...(DocumentFormSettingsKey.filter(k => k !== "digital-maturity-assessment") as Exclude<DocumentFormSettingsKey, "digital-maturity-assessment">[]),
  ...VideoFormSettingsKey,
  "recommended-resources",
  "general-modal"
] as const;

const PostSubmitFieldType =["BlindSubmitHeading", "BlindSubmitBody", "Heading", "Body", "Download"] as const;
type PostSubmitFieldType =typeof PostSubmitFieldType[number];

type FormPostSubmitTypes< TName extends string, TState extends string> =`${TName}-${TState}`;
export type FormTypeSubmitField = FormPostSubmitTypes<AllFormTypes, PostSubmitFieldType> 

export type FormPostSubmitFields = {
    readonly [Key in FormTypeSubmitField]: string;
  };




